import React, { useEffect, useState, useRef } from "react"
import { Link, useLocation } from "react-router-dom"
import "./navbar.css"

// Private Component
import { userService } from "../../_services"


const Justnavbar = () => {
    const [userCompanyName, setUserCompanyName] = useState(localStorage.getItem("cname"))
    const [isConnected, setIsConnected] = useState(userService.getUserConnexionStatus())
    const [menuOpen, setMenuOpen] = useState(false)
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const [scrolled, setScrolled] = useState(false)
    const [pulsing, setPulsing] = useState(true)
    const dropdownRef = useRef(null)
    const location = useLocation()

    useEffect(() => {
        !localStorage.getItem("cname")
            ? setUserCompanyName(undefined)
            : setUserCompanyName(localStorage.getItem("cname"))
        setIsConnected(userService.getUserConnexionStatus())
    })

    useEffect(() => {
        const timer = setTimeout(() => setPulsing(false), 4000)
        return () => clearTimeout(timer)
    }, [])

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 20)
        window.addEventListener("scroll", handleScroll)
        return () => window.removeEventListener("scroll", handleScroll)
    }, [])

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setDropdownOpen(false)
            }
        }
        document.addEventListener("mousedown", handleClickOutside)
        return () => document.removeEventListener("mousedown", handleClickOutside)
    }, [])

    // Close mobile menu on route change
    useEffect(() => {
        setMenuOpen(false)
        setDropdownOpen(false)
    }, [location])

    const partnerItems = !isConnected
        ? [
            { to: "/moveon", icon: "✦", label: "Créer un compte Pro", internal: true },
            { to: "/partenaires", icon: "✧", label: "Nos partenaires", internal: true },
            { to: "/restaurateurs", icon: "🍴", label: "Restaurateurs", internal: true },
            { to: "/grands-comptes", icon: "❏", label: "Grands Comptes", internal: true },
            { href: "/about#section_contact", icon: "◎", label: "Nous contacter" },
            { href: "/legal/cgu.html", icon: "◉", label: "Mentions Légales" },
        ]
        : [
            { to: "/dashboard", icon: "⊞", label: "Tableau de bord", internal: true },
            { to: "/adminpro", icon: "⊕", label: "Ajouter un événement", internal: true },
            { to: "/moncomptepro", icon: "◎", label: "Mon compte", internal: true },
            { to: "/premiumpro", icon: "★", label: "Premium", internal: true, premium: true },
            { to: "/login", icon: "◁", label: "Déconnexion", internal: true },
        ]

    return (
        <header className={`jn-navbar${scrolled ? " jn-navbar--scrolled" : ""}`}>
            <nav className="jn-navbar__inner">
                {/* Logo */}
                <Link to="/" className="jn-navbar__brand">
                    <img src="/logo_justnow.png" alt="JustNow" className="jn-navbar__logo" />
                    <span className={`jn-navbar__brand-pulse${pulsing ? "" : " jn-navbar__brand-pulse--stopped"}`} />
                </Link>

                {/* Desktop links */}
                <div className="jn-navbar__links">
                    <a href="/a-propos" className="jn-navbar__link">
                        Comment ça marche
                    </a>

                    {/* Dropdown */}
                    <div className="jn-dropdown" ref={dropdownRef}>
                        <button
                            className={`jn-navbar__link jn-dropdown__trigger${dropdownOpen ? " active" : ""}`}
                            onClick={() => setDropdownOpen((v) => !v)}
                            aria-expanded={dropdownOpen}
                        >
                            {isConnected && userCompanyName ? userCompanyName : "Partenaires"}
                            <span className="jn-dropdown__arrow">▾</span>
                        </button>

                        <div className={`jn-dropdown__panel${dropdownOpen ? " jn-dropdown__panel--open" : ""}`}>
                            {partnerItems.map((item, i) =>
                                item.internal ? (
                                    <Link
                                        key={i}
                                        to={item.to}
                                        className={`jn-dropdown__item${item.premium ? " jn-dropdown__item--premium" : ""}`}
                                        onClick={() => setDropdownOpen(false)}
                                    >
                                        <span className="jn-dropdown__item-icon">{item.icon}</span>
                                        {item.label}
                                    </Link>
                                ) : (
                                    <a
                                        key={i}
                                        href={item.href}
                                        className="jn-dropdown__item"
                                        onClick={() => setDropdownOpen(false)}
                                    >
                                        <span className="jn-dropdown__item-icon">{item.icon}</span>
                                        {item.label}
                                    </a>
                                )
                            )}
                        </div>
                    </div>

                    <a href="/carte" className="jn-navbar__link jn-navbar__link--cta">
                        <span>Voir la carte</span>
                        <span className={`jn-navbar__link-dot${pulsing ? "" : " jn-navbar__link-dot--stopped"}`} />
                    </a>
                </div>

                {/* Burger */}
                <button
                    className={`jn-burger${menuOpen ? " jn-burger--open" : ""}`}
                    onClick={() => setMenuOpen((v) => !v)}
                    aria-label="Menu"
                >
                    <span /><span /><span />
                </button>
            </nav>

            {/* Mobile panel */}
            <div className={`jn-mobile-menu${menuOpen ? " jn-mobile-menu--open" : ""}`}>
                <a href="/a-propos" className="jn-mobile-menu__link">Comment ça marche</a>

                <div className="jn-mobile-menu__group">
                    <p className="jn-mobile-menu__group-label">
                        {isConnected && userCompanyName ? userCompanyName : "Partenaires"}
                    </p>
                    {partnerItems.map((item, i) =>
                        item.internal ? (
                            <Link
                                key={i}
                                to={item.to}
                                className={`jn-mobile-menu__link jn-mobile-menu__link--sub${item.premium ? " jn-mobile-menu__link--premium" : ""}`}
                            >
                                <span>{item.icon}</span> {item.label}
                            </Link>
                        ) : (
                            <a
                                key={i}
                                href={item.href}
                                className="jn-mobile-menu__link jn-mobile-menu__link--sub"
                            >
                                <span>{item.icon}</span> {item.label}
                            </a>
                        )
                    )}
                </div>

                <a href="/carte" className="jn-mobile-menu__link jn-mobile-menu__link--cta">
                    Voir la carte
                </a>
            </div>
        </header>
    )
}

export default Justnavbar
